export const API_PREFIX_POST_PATH = "/api/posts"
export const API_PREFIX_TAG_PATH = "/api/tags"
export const API_PREFIX_MEDIA_PATH = "/api/upload"

export const API_PREFIX_BLOCK_CONTENT_PATH = "/api/block-contents"
export const API_PREFIX_CATEGORY_PATH = "/api/cateogries"
export const API_PREFIX_MENU_PREFERENCE_PATH = "/api/menu-preferences"

export const API_PREFIX_PAGE_PATH = "/api/pages"
export const API_PREFIX_SETTING_PATH = "/api/settings"
export const API_PREFIX_PRODUCT_PATH = "/api/products"
export const API_PREFIX_PRODUCT_CATEGORY_PATH = "/api/product-categories"
export const API_PREFIX_CONTACT_FORM_PATH = "/api/form-submits"
export const API_PREFIX_ORDER_PATH = "/api/orders"
export const API_PREFIX_ORDER_ITEMS_PATH = "/api/order-items"
export const API_PREFIX_PROMOTION_CODES_PATH = "/api/promotion-codes"
export const API_PREFIX_CUSTOMERS_PATH = "/api/customers"

export const API_PREFIX_USERS_PATH = "/api/users"
export const API_PREFIX_ROLES_PATH = "/api/users-permissions/roles"
export const API_PREFIX_DESTINATION_PATH = "/api/destinations"
export const API_PREFIX_TOUR_PATH = "/api/tour-v2s"
export const API_PREFIX_BIKE_TYPE_PATH = "/api/bike-types"
